// extracted by mini-css-extract-plugin
export default {"cardsPage":"CardsPage_cardsPage__AFpON","contentContainer":"CardsPage_contentContainer__xMaF2"};